import type { ILogoFinderResponse } from "@/shared/types";
import type { IMediaLibLogo } from "../types";

export const mapMediaLibLogoFinderData = (
  data: ILogoFinderResponse,
  alt?: string,
): IMediaLibLogo[] => {
  return data.logos.logos.map((logo) => {
    let src = logo.formats[0].src;

    const png = logo.formats.find(({ format }) => format === "png");
    if (png) src = png.src;
    else {
      const svg = logo.formats.find(({ format }) => format === "svg");
      if (svg) src = svg.src;
    }

    return {
      alt,
      color: "color",
      type: logo.type,
      originalSrc: src,
      src: src,
    };
  });
};
